function Container({children}){
    return(
        <div className="w-5/6 items-center mx-auto flex">
            {children}
        </div>
    )

}
export default Container;